import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52f0484a&scoped=true&shadow"
import script from "./index.vue?vue&type=script&lang=js&shadow"
export * from "./index.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=52f0484a&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "52f0484a",
  null
  ,true
)

export default component.exports